import { IonIcon, IonSpinner } from '@ionic/react'
import {
	checkmarkCircleOutline,
	chevronForward,
	informationCircleOutline,
	mailOutline,
	shieldHalf,
} from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useUser from '../../../contexts/hooks/useUser'
import { useAuthorizations } from '../../../hooks/useAuthorizations'

const ProfileHeaderCard: React.FC = () => {
	const { t } = useTranslation('pages_settings')
	const { user, isCustomer } = useUser()
	const history = useHistory()

	const { data: authorizationsData, isFetching: isFetchingAuthorizations } = useAuthorizations()

	const hasActiveAuthorization = (authorizationsData?.Agreements?.length ?? 0) > 0

	return (
		<div
			onClick={() => history.push('/settings/account-management')}
			className='flex flex-row items-center justify-between rounded-xl p-6 shadow-md group hover bg-white dark:bg-brand-secondary-200-dark'
		>
			<div className='flex flex-row items-center gap-4'>
				<div className='flex items-center justify-center shrink-0 w-11 h-11 rounded-full bg-brand-primary-100-light/15 dark:bg-brand-primary-100-dark/15'>
					<IonIcon
						className='text-[1.4rem] text-brand-primary-100-light dark:text-brand-primary-100-dark'
						icon={shieldHalf}
					/>
				</div>

				<div className='flex flex-col gap-1'>
					<span className='text-text-dark dark:text-white font-semibold'>
						{t('accountManagement.title')}
					</span>

					{user?.email && (
						<div className='flex flex-row items-center gap-2'>
							<IonIcon
								className='text-[0.9rem] text-text-grey-200 dark:text-white/60 shrink-0'
								icon={mailOutline}
							/>
							<span className='text-text-grey-200 dark:text-white/60 text-xs break-all'>
								{user.email}
							</span>
						</div>
					)}

					{isCustomer ? (
						<div className='flex flex-row items-center gap-2 text-green-600 dark:text-green-400 text-xs font-semibold'>
							<IonIcon icon={checkmarkCircleOutline} className='text-sm shrink-0' />
							<span>{t('profileHeader.customer')}</span>
						</div>
					) : (
						<div className='flex flex-row items-center gap-2 text-xs font-semibold'>
							<IonIcon
								icon={informationCircleOutline}
								className='text-sm shrink-0 text-text-grey-200 dark:text-white/70'
							/>
							{isFetchingAuthorizations ? (
								<IonSpinner className='h-3 w-3' />
							) : (
								<span
									className={
										hasActiveAuthorization ? 'text-green-600 dark:text-green-400' : 'text-red-400'
									}
								>
									{hasActiveAuthorization
										? t('profileHeader.authorizationsActive', {
												count: authorizationsData?.Agreements?.length,
											})
										: t('profileHeader.authorizationsNotFound')}
								</span>
							)}
						</div>
					)}
				</div>
			</div>

			<IonIcon
				className='text-[2.15rem] text-[#a3a3a3] dark:text-[#c8c8c8] transition-transform group-hover:scale-[1.2] group-hover:transition-transform shrink-0'
				icon={chevronForward}
			/>
		</div>
	)
}

export default ProfileHeaderCard
